import script from "./ProposalVotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalVotes.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__